import auth, { IVerifyMfaCode } from '../services/auth';
import routes from '../constants/routes';
import routing from '../services/routing';

export default async (formData: IVerifyMfaCode) => {
    await auth.verifyMfaCode(formData);
    routing.push(routes.COMPLETE_MFA_SETUP);
};
